export default "__VITE_ASSET__WFTXIIN1__"